<app-sidebar></app-sidebar>

<div class="date-display" *ngIf="date">
  <p>{{ date | correctedDate | date }}</p>
  @if (ride()) {
    <app-ride-name-editor
      [rideId]="rideId"
      [initialName]="ride()?.rideName ?? ''">
    </app-ride-name-editor>
  }
</div>


<div class="map-container">
    <app-map [mode]="'route history'" *ngIf="routes()" [routes]="routes()"></app-map>
</div>


<div class="route-table-container">
    <table>
        <thead>
            <tr>
                <th></th>
                <th>Start time</th>
                <th>End time</th>
                <th>Udaljenost</th>
                <th>Trajanje</th>
                <th>Prosječna brzina</th>
            </tr>
        </thead>
        <tbody>
            @for(route of routes(); track route.id; let i = $index) {
                <tr class="clickable-row" routerLink="/route-details/{{ route.id }}">
                    <td> {{ i + 1 }}. </td>
                    <td>{{ route.startTime | date: 'HH:mm:ss' }}</td>
                    <td>{{ route.endTime | date: 'HH:mm:ss' }}</td>
                    <td>{{ route.distance | distanceConverter }}</td>
                    <td>{{ route.duration | duration }}</td>
                    <td>{{ ((route.distance / route.duration) * 3.6) | number:'1.2-2' }} km/h</td>
                </tr>
                <tr><td colspan="6" class="menu-separator"></td></tr>
            }
        </tbody>
    </table>
</div>

<div class="altitude-graph-center">
    <app-altitude-and-speed-graph *ngIf="routes()" [routes]="routes()"></app-altitude-and-speed-graph>
</div>
